import { BASE_API_URL } from "../../../services/config";

// api_rules / formgroup_api_rules / barcode rules objects persist both an
// apiendPointField (relative, e.g. "customApidata/lookup?x=@x") and a legacy
// baked-in absolute `url` computed from whatever BASE_API_URL was active when
// the form was last saved in the builder. Trusting that stored `url` at
// submission time calls the wrong server whenever the form is used in a
// different environment (local/qa/uat/prod) than the one it was built in.
// Always rebuild against the environment this app is currently running in.
export const resolveRuleUrl = (rule) => {
  if (!rule) return "";
  // `url` (when present) carries the query string too, e.g.
  // "/api/v1/customApidata/lookup?customer_name=@customer_name" — that query
  // string is NOT duplicated onto apiendPointField, so url must win whenever
  // it exists; apiendPointField is only a fallback for rules saved without a url.
  const rawUrl = rule.url || "";
  const marker = "/api/v1/";
  if (rawUrl) {
    const idx = rawUrl.indexOf(marker);
    const extractedEndpoint = idx === -1 ? rawUrl : rawUrl.slice(idx + marker.length);
    return extractedEndpoint ? `${BASE_API_URL}${marker}${extractedEndpoint}` : rawUrl;
  }
  const endpoint = rule.apiendPointField || rule.endpoint;
  return endpoint ? `${BASE_API_URL}${marker}${endpoint}` : "";
};
